import React from 'react';
import {ComponenteGerenciarPedidos } from '../../../componentes/componente-gerenciar-pedidos/index'
const GerenciarOS = () => {
    return (
        <ComponenteGerenciarPedidos tipo="ORDEM_SERVICO" titulo="Gerenciar Ordem de Serviço" ></ComponenteGerenciarPedidos>
    )  
}
 
export {GerenciarOS};